module.exports = __webpack_public_path__ + "static/img/icon-zhenguo-large.9a85a2dc.svg";